// extracted by mini-css-extract-plugin
export default {"main":"MultiStatusView_main__kOwc0","more":"MultiStatusView_more__cWIpu"};